import { hsaAnswer } from "@redotech/redo-conversion-hsa-common/hsa-answer";
import { HsaAnswerValidationErrorCode } from "@redotech/redo-conversion-hsa-common/hsa-answer-validate";
import { unaryRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum HsaSubmitAnswerStatus {
  OK = "ok",
  VALIDATION_ERROR = "validation_error",
}

const hsaAnswerValidationErrorCodeSchema = createEnum(
  HsaAnswerValidationErrorCode,
  { enumName: "HsaAnswerValidationErrorCode" },
);

const hsaAnswerValidationErrorWire_ = z.object({
  code: hsaAnswerValidationErrorCodeSchema,
  questionHandle: z.string().min(1),
  message: z.string(),
});

// Per-question incremental save. The answer carries its own
// `questionHandle`, so the input doesn't repeat it. Idempotent on
// (session_id, question_handle): re-submitting overwrites the row.
//
// Validation errors come back in the response (not as an RPC failure) so
// the client can render inline field errors. The client mirrors the same
// validators (from `hsa-common`) for instant feedback; the server is the
// authority.
export const submitHsaAnswer = unaryRpc({
  name: "submitHsaAnswer",
  input: z.object({ sessionToken: z.string().uuid(), answer: hsaAnswer }),
  output: z.discriminatedUnion("status", [
    z.object({ status: z.literal(HsaSubmitAnswerStatus.OK) }),
    z.object({
      status: z.literal(HsaSubmitAnswerStatus.VALIDATION_ERROR),
      errors: z.array(hsaAnswerValidationErrorWire_).min(1),
    }),
  ]),
});
